import * as bootstrap from "bootstrap";
import htmx from "htmx.org";
import { initHtmxLifecycle } from "./js/htmx-lifecycle.js";
import { initSessionStopModal } from "./js/session-stop-modal.js";
import "./styles.scss";

window.htmx = htmx;

function initToasts() {
  [...document.querySelectorAll("#toast-container .toast")].forEach(
    (toastEl) => {
      const toast = new bootstrap.Toast(toastEl);
      toast.show();
      toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove(), {
        once: true,
      });
    },
  );
}

const { initTooltips } = initHtmxLifecycle({ bootstrap });

document.addEventListener("DOMContentLoaded", () => {
  initToasts();
  initTooltips();
  initSessionStopModal();

  const pageType = document.body.dataset.pageType;

  switch (pageType) {
    case "simu_list":
      import("./js/simu_list.js").then((module) => module.init());
      break;
    case "simu_session":
      import("./js/simu_session.js").then((module) => module.init());
      break;
    case "simu_run":
      import("./js/simu_run.js").then((module) => module.init());
      break;
    case "simu_history":
      import("./js/simu_history.js").then((module) => module.init());
      break;
    case "simu_parametres":
      import("./js/simu_parametres.js").then((module) => module.init());
      break;
    case "simu_synthesis":
      import("./js/simu_synthesis.js").then((module) => module.init());
      break;
    case "settings":
      import("./js/settings.js").then((module) => module.init());
      break;
    case "simu_monitor":
      import("./js/simu_monitor.js").then((module) => module.init());
      break;
    case "simu_defibrillator":
      import("./js/simu_defibrillator.js").then((module) => module.init());
      break;
    case "simu_dae":
      import("./js/simu_dae.js").then((module) => module.init());
      break;
    case "simu_preset_edit":
      import("./js/simu_preset_edit.js").then((module) => module.init());
      break;
    case "workspace_manage":
      import("./js/workspace_manage.js").then((module) => module.init());
      break;
    case "workspace_billing":
      import("./js/workspace_billing.js").then((module) => module.init());
      break;
  }
});
